module.exports = __webpack_public_path__ + "img/logo_maxipas_1.bbdfe6ed.png";